const encode = input => new URLSearchParams(input).toString()
export default encode
